// ConfirmModal.js
import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  text1,
  text2,
  close = "No",
  accept = "Yes",
  field = false,
  formData,
  setFormData,
  handleSubmit,
  isLoading,
}) => {
  if (!isOpen) return null; // Don't render if not open
  const handleChange = async (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 shadow-lg">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => onClose(true)}
            className="cursor-pointer"
          />
        </div>
        <h2 className="text-lg font-semibold">{text1}</h2>
        <p className="mt-2">{text2}</p>
        {field && (
          <form
            onSubmit={handleSubmit}
            className="py-12  flex flex-col justify-center items-center gap-6 "
          >
            <div className="flex flex-col gap-6 ">
              <div className="flex flex-col">
                <label htmlFor="">Name</label>
                <input
                  className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
                  placeholder="Customer Name"
                  type="text "
                  name="name"
                  // id="email"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="">Email or phone number</label>
                <input
                  className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
                  placeholder="Email or phone number"
                  type="text"
                  // id="email"
                  name="preference"
                  value={formData.preference}
                  onChange={handleChange}
                  pattern="(^[0-9]+$)|(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)"
                  // required
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="">Comment</label>
                <input
                  className="border-2 border-gray-300 p-2  min-h-[100px] text-start rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
                  placeholder="Comment"
                  type="text "
                  name="comment"
                  // id="email"
                  value={formData.comment}
                  onChange={handleChange}
                  // required
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500 hover:bg-blue-600"
            >
              {isLoading ? "Submitting.." : "Submit"}
            </button>
          </form>
        )}
        {!field && (
          <div className="mt-4 flex justify-end">
            <button
              className="mr-2 px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              onClick={onClose}
            >
              {close}
            </button>
            <button
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={onConfirm}
            >
              {accept}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmModal;
